import { Content } from "@/ui";
import { getRoute } from "@/functions/getRoute";
import unslug from "unslug";
import { simple_pages_helper } from "@/helpers/simple_pages_helper";
import { jobs_helper } from "@/helpers/jobs_helper";
import { createTitle } from "@/functions/createTitle";
import { consultant_helper } from "@/helpers/consultant_helper";
import { content_tiles_helper } from "@/helpers/content_tiles_helper";
import { instagram_helper } from "@/helpers/instagram_helper";
import { benefits_helper } from "@/helpers/benefits_helper";
import { values_helper } from "@/helpers/values_helper";
import { relocations_helper } from "@/helpers/relocations_helper";
import { employee_feedback_helper } from "@/helpers/employee_feedback_helper";
import SeoHead from "@/components/SeoHead";
import { specialisms_helper } from "@/helpers/specialisms_helper";

export default function Page({ content, meta }) {
  return (
    <>
      <SeoHead canonical_link={`https://www.earthstreamglobal.com/${meta.url_slug}`} />
      <Content items={content} />
    </>
  );
}

export async function getStaticProps({ params: { url_slugs } }) {
  const pages = url_slugs.map((url_slug, k) => ({
    url_slug,
    label: unslug(url_slug),
    href: getRoute("dynamic", { url_slugs: url_slugs.slice(0, k + 1) }),
  }));
  let [_page, prevPage] = [...pages].reverse();
  const page = simple_pages_helper.find(_page.url_slug);
  const specialism = specialisms_helper.find(_page.url_slug);
  if (!page) {
    return {
      notFound: true,
    };
  }

  const filtered_pages = pages.filter((_page) => {
    return _page.url_slug != "specialisms" && _page.url_slug != "disciplines";
  });

  const all_jobs = jobs_helper
    .fetch()
    .filter((job) => (specialism?.id ? JSON.stringify(job.categories).includes(specialism.id) : true));

  const url_slug = url_slugs.join("/");

  return {
    props: {
      meta: {
        title: createTitle(...pages.map((i) => i.label).reverse()),
        url_slug: url_slug,
      },
      content: [
        {
          component: "BreadcrumbNavigation",
          props: {
            items: filtered_pages,
            className: "mt-2",
          },
        },
        page.simple_page
          ? {
              component: "HeroSimple",
              id: "HeroSimple",
              props: {
                title: page.title || "",
                body: page.description || "",
                link: page.thank_you_page || "",
                formId: page.form_id || "",
                image: page.image || page.hero_image || "",
                thank_you_page: page.thank_you_page || "",
                newTab: page.new_tab || "",
                thank_you_page: "/thank-you",
              },
            }
          : {
              component: "Hero2",
              id: "Hero2",
              props: {
                label: page.title,
                highlight: page.highlighted_title || "",
                content: page.subtitle || "",
                body: page.description || "",
                moreBody: page.read_more_description || "",
                className: "hero-section",
                ctas: page.ctas || [],
                link: page.read_more_link || "",
                image: page.hero_image || "",
              },
            },
        page.specialism_categories && page.specialism_categories.length == 1 && page.specialism_categories[0].parent_id
          ? {
              component: "SpecialismCategories",
              id: "SpecialismCategories",
              props: {
                label: page.specialism_categories[0].specialism_title,
                parentId: page.specialism_categories[0].parent_id,
                slug: page.url_slug,
              },
            }
          : {},
        page.social_title
          ? {
              component: "Carousel",
              props: {
                title: "",
                items: instagram_helper.fetch(),
              },
            }
          : {},
        page.benefits_title
          ? {
              component: "Benefits",
              props: {
                title: page.benefits_title,
                benefits: benefits_helper.fetch(),
              },
            }
          : {},
        page.values_title
          ? {
              component: "OurValues",
              props: {
                title: page.values_title,
                brands: values_helper.fetch(),
              },
            }
          : {},
        page.employee_feedbacks
          ? {
              component: "EmployeeFeedbacks",
              props: {
                items: employee_feedback_helper.fetch(),
              },
            }
          : {},
        page.id != "8e2fe9d7-0508-45a8-bac1-bb0e67ccb46a" && page.latest_jobs_title
          ? {
              component: "LatestJobs",
              id: "LatestJobs",
              props: {
                title: page.url_slug,
                jobs: all_jobs,
                variant: "tertiary",
                internal: false,
              },
            }
          : {},
        page.meet_the_team_title
          ? {
              component: "MeetTheTeamPanel",
              props: {
                title: `Meet The ${page.url_slug} Team`,
                members: consultant_helper.fetch({ specialty: page.specialism }),
              },
            }
          : {},
        page.ceo_statement
          ? {
              component: "CEOStatement",
              props: {
                statement: page.ceo_statement || "",
                content: page.ceo_content || "",
                image: { path: "ceo.image" },
                name: page.ceo_name || "",
              },
            }
          : {},
        page.charity_statement
          ? {
              component: "CharityStatement",
              props: {
                statement: page.charity_statement,
                content: page.charity_content,
                image: page.charity_image,
              },
            }
          : {},
        page.carousel_category
          ? {
              component: "HomeTiles",
              props: {
                items: content_tiles_helper.fetch({ category: page.carousel_category }),
                style: page.carousel_style || "",
              },
            }
          : {},
        page.relocation_title
          ? {
              component: "Relocations",
              props: {
                title: page.relocation_title,
                body: page.relocation_description,
                items: relocations_helper.fetch(),
              },
            }
          : {},
        page.blog_title
          ? {
              component: "LatestBlogs",
              props: {
                title: page.blog_title,
                variant: "quaternary",
              },
            }
          : {},
        page.reviews_title
          ? {
              component: "FeefoReviews",
              props: {
                title: page.reviews_title,
              },
            }
          : {},
        page.show_ethy
          ? {
              component: "EthyWidget",
            }
          : {},
        page.id == "8e2fe9d7-0508-45a8-bac1-bb0e67ccb46a" && page.latest_jobs_title
          ? {
              component: "LatestJobs",
              id: "LatestJobs",
              props: {
                title: page.latest_jobs_title,
                jobs: all_jobs,
                variant: "tertiary",
              },
            }
          : {},
        page.seo_job_description
          ? {
              component: "SeoJobsFeed",
              props: {
                description: page.seo_job_description,
                links: page.seo_links,
              },
            }
          : {},
      ],
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: simple_pages_helper.toNestedPaths({
      exclude: [
        "c5fa9aeb-0606-4e67-ab43-427c0d0a23e4", // About us
        "4651a5c3-4045-42ec-8e19-3436fceb0754", // Disciplines
      ],
    }),
    fallback: false,
  };
}
